import authService from '../API/AuthService';
import { AppDispatch } from '../App/store';
import { FormData, Member, RegisteredMember } from '../Interface/Login.interface';

import { loadFromStorage, setCustomerData, setLogin, setRegister } from '../Slice/Auth.Slice';


export const loginUser = (payload: FormData) =>
  async (dispatch: AppDispatch) => {
    try {
      const data = await authService.login(payload);
      const dataValue = JSON.parse(data)
      const user = dataValue;

      dispatch(setLogin(user));
      localStorage.setItem('auth', data);

    } catch (error) {
      console.error('Login failed:', error);
    }
  };

export const RegisterUser = (payload: Member) => async (dispatch: AppDispatch) => {
  try {
    const data = await authService.Register(payload);
    dispatch(setRegister(data));
    return { success: true, data }; 
  } catch (error) {
    console.error('Registration error:', error);
    return { success: false };      
  }
};


export const GetCustomerData = () => async(dispatch:AppDispatch) =>{
  try{
    
    const response = await authService.getCustomerData();
    const data = JSON.parse(response)
    dispatch(setCustomerData(data))

  }
  catch(error){
    console.error('Error in the GetCustomerData')
  }
}